// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (max-width: 768px) {
  .task-form-container {
    padding: 1rem;
  }
}

.modal-mode-task-content-task-form-container {
  padding: 0rem !important;
  min-height: auto;
}

.task-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: task-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .task-form-wrapper {
    padding: 1rem;
    width: 100%;
  }
}
.task-form-wrapper .task-form-header {
  position: relative;
  text-align: center;
  margin-bottom: 0rem;
}
.task-form-wrapper .task-form-header .task-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
@media (max-width: 768px) {
  .task-form-wrapper .task-form-header .task-form-title {
    font-size: 1.25rem;
  }
}
.task-form-wrapper .task-form-header .modal-mode-task-content-task-form-title {
  font-size: 1.3rem !important;
  font-weight: 500 !important;
}
.task-form-wrapper .task-form-header .task-form-close-button {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 24px;
  background: transparent;
  border: none;
  color: #374151;
  cursor: pointer;
  z-index: 2;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.task-form-wrapper .task-form-header .task-form-close-button:hover {
  color: #111827;
  background-color: #f3f4f6;
}
.task-form-wrapper .task-status-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  margin: 1.5rem 0 0 0;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  background-color: #f9fafb;
}
.task-form-wrapper .task-status-section .current-status,
.task-form-wrapper .task-status-section .status-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.task-form-wrapper .task-status-section .status-label {
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.task-form-wrapper .task-status-section .status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.875rem;
  border-radius: 9999px;
  font-size: 0.8125rem;
  font-weight: 500;
  color: white;
}
.task-form-wrapper .task-status-section .status-badge svg {
  color: white;
}
.task-form-wrapper .task-status-section .status-buttons {
  display: flex;
  gap: 0.75rem;
}
.task-form-wrapper .task-status-section .status-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.875rem;
  border: 1.5px solid;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  background-color: transparent;
  transition: all 0.2s ease-in-out;
}
.task-form-wrapper .task-status-section .status-button:hover:not(:disabled) {
  opacity: 0.8;
  transform: translateY(-1px);
}
.task-form-wrapper .task-status-section .status-button.active {
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.task-form-wrapper .task-status-section .status-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}
.task-form-wrapper .task-status-section .status-button:disabled:hover {
  opacity: 0.6;
}
.task-form-wrapper .task-form-divider {
  border: none;
  border-top: 1px solid var(--grey-shade-two);
  margin: 1.5rem 0;
}
.task-form-wrapper .task-tabs {
  display: flex;
  border: 1px solid var(--grey-shade-three);
  border-radius: 0.375rem 0.375rem 0 0;
  overflow: hidden;
  margin-bottom: 0;
}
.task-form-wrapper .task-tabs .tab-button {
  flex: 1 1;
  padding: 1rem 1.5rem;
  background: #ffffff;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  color: #6b7280;
}
.task-form-wrapper .task-tabs .tab-button.active {
  background-color: var(--grey-shade-two);
  color: #374151;
  border-bottom: 2px solid var(--grey-shade-one);
}
.task-form-wrapper .task-tabs .tab-button:hover:not(.active) {
  background-color: var(--grey-lightest-shade);
}
.task-form-wrapper .modal-mode-task-content {
  width: 100% !important;
  margin: 0 !important;
}
.task-form-wrapper .task-form-content,
.task-form-wrapper .form-content {
  padding: 1.5rem;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 0.375rem 0.375rem;
  background-color: #ffffff;
  margin: 0 -1.5rem -1.5rem -1.5rem;
}
@media (max-width: 768px) {
  .task-form-wrapper .task-form-content,
  .task-form-wrapper .form-content {
    padding: 1rem;
    margin: 0 -1rem -1rem -1rem;
  }
}
.task-form-wrapper .form-section {
  margin-bottom: 1.5rem;
}
.task-form-wrapper .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.task-form-wrapper .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--grey-shade-two);
}
.task-form-wrapper .form-group {
  margin-bottom: 0.7rem;
  width: 100%;
}
.task-form-wrapper .form-group:last-child {
  margin-bottom: 0;
}
.task-form-wrapper .form-group .label-task {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.task-form-wrapper .form-group .label-task .required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.task-form-wrapper .form-group input[type=text],
.task-form-wrapper .form-group input[type=date],
.task-form-wrapper .form-group input[type=time],
.task-form-wrapper .form-group input[type=url],
.task-form-wrapper .form-group select,
.task-form-wrapper .form-group .custom-dropdown-input,
.task-form-wrapper .form-group .textInput,
.task-form-wrapper .form-group .selectInput {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151 !important;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.task-form-wrapper .form-group input[type=text]:focus,
.task-form-wrapper .form-group input[type=date]:focus,
.task-form-wrapper .form-group input[type=time]:focus,
.task-form-wrapper .form-group input[type=url]:focus,
.task-form-wrapper .form-group select:focus,
.task-form-wrapper .form-group .custom-dropdown-input:focus,
.task-form-wrapper .form-group .textInput:focus,
.task-form-wrapper .form-group .selectInput:focus {
  outline: none;
  border-color: var(--primary-light-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.task-form-wrapper .form-group input[type=text]:hover:not(:focus),
.task-form-wrapper .form-group input[type=date]:hover:not(:focus),
.task-form-wrapper .form-group input[type=time]:hover:not(:focus),
.task-form-wrapper .form-group input[type=url]:hover:not(:focus),
.task-form-wrapper .form-group select:hover:not(:focus),
.task-form-wrapper .form-group .custom-dropdown-input:hover:not(:focus),
.task-form-wrapper .form-group .textInput:hover:not(:focus),
.task-form-wrapper .form-group .selectInput:hover:not(:focus) {
  border-color: var(grey-main-bg);
}
.task-form-wrapper .form-group input[type=text]::placeholder,
.task-form-wrapper .form-group input[type=date]::placeholder,
.task-form-wrapper .form-group input[type=time]::placeholder,
.task-form-wrapper .form-group input[type=url]::placeholder,
.task-form-wrapper .form-group select::placeholder,
.task-form-wrapper .form-group .custom-dropdown-input::placeholder,
.task-form-wrapper .form-group .textInput::placeholder,
.task-form-wrapper .form-group .selectInput::placeholder {
  color: var(grey-main-bg);
}
.task-form-wrapper .form-group input[type=text]:disabled,
.task-form-wrapper .form-group input[type=date]:disabled,
.task-form-wrapper .form-group input[type=time]:disabled,
.task-form-wrapper .form-group input[type=url]:disabled,
.task-form-wrapper .form-group select:disabled,
.task-form-wrapper .form-group .custom-dropdown-input:disabled,
.task-form-wrapper .form-group .textInput:disabled,
.task-form-wrapper .form-group .selectInput:disabled {
  background-color: #e9ecef;
  color: #6b7280;
  cursor: not-allowed;
}
.task-form-wrapper .form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.task-form-wrapper .form-group .case-selector {
  position: relative;
}
.task-form-wrapper .form-group .case-selector .dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  z-index: 1000;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-tabs button {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-tabs button:hover {
  background: #f3f4f6;
  color: #374151;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-tabs button.active {
  background: #ffffff;
  color: var(--primary-light-color);
  font-weight: 600;
  border-bottom-color: var(--primary-light-color);
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options {
  max-height: 250px;
  overflow-y: auto;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option:hover {
  background: #f9fafb;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option.selected .case-parties {
  font-weight: 600;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  margin-bottom: 0.25rem;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.task-form-wrapper .form-group .case-selector .dropdown-content .dropdown-options .no-data {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.task-form-wrapper .date-time-wrapper,
.task-form-wrapper .expense-form-flex-row {
  display: flex;
  gap: 1rem;
  width: 100%;
  margin-bottom: 0.7rem;
}
@media (max-width: 768px) {
  .task-form-wrapper .date-time-wrapper,
  .task-form-wrapper .expense-form-flex-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.task-form-wrapper .date-time-wrapper .date-time-group,
.task-form-wrapper .date-time-wrapper .expense-form-col-half,
.task-form-wrapper .expense-form-flex-row .date-time-group,
.task-form-wrapper .expense-form-flex-row .expense-form-col-half {
  flex: 1 1;
  margin-bottom: 0;
}
.task-form-wrapper .date-time-wrapper .date-time-group .time-div-task-content,
.task-form-wrapper .date-time-wrapper .expense-form-col-half .time-div-task-content,
.task-form-wrapper .expense-form-flex-row .date-time-group .time-div-task-content,
.task-form-wrapper .expense-form-flex-row .expense-form-col-half .time-div-task-content {
  display: flex;
  justify-content: flex-end;
}
.task-form-wrapper .date-time-wrapper .date-time-group .date-time-input-task,
.task-form-wrapper .date-time-wrapper .expense-form-col-half .date-time-input-task,
.task-form-wrapper .expense-form-flex-row .date-time-group .date-time-input-task,
.task-form-wrapper .expense-form-flex-row .expense-form-col-half .date-time-input-task {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.task-form-wrapper .date-time-wrapper .date-time-group .date-time-input-task:focus,
.task-form-wrapper .date-time-wrapper .expense-form-col-half .date-time-input-task:focus,
.task-form-wrapper .expense-form-flex-row .date-time-group .date-time-input-task:focus,
.task-form-wrapper .expense-form-flex-row .expense-form-col-half .date-time-input-task:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.task-form-wrapper .date-time-wrapper .date-time-group .date-time-input-task:hover:not(:focus),
.task-form-wrapper .date-time-wrapper .expense-form-col-half .date-time-input-task:hover:not(:focus),
.task-form-wrapper .expense-form-flex-row .date-time-group .date-time-input-task:hover:not(:focus),
.task-form-wrapper .expense-form-flex-row .expense-form-col-half .date-time-input-task:hover:not(:focus) {
  border-color: #9ca3af;
}
.task-form-wrapper .assignee-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.task-form-wrapper .assignee-section .dropdown-container {
  width: 100%;
}
.task-form-wrapper .assignee-section .assignee-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.task-form-wrapper .assignee-section .assignee-tags .assignee-tag {
  display: flex;
  align-items: center;
  background-color: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 0.375rem;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  color: #374151;
}
.task-form-wrapper .assignee-section .assignee-tags .assignee-tag .remove-assignee {
  margin-left: 0.5rem;
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  transition: all 0.2s ease;
}
.task-form-wrapper .assignee-section .assignee-tags .assignee-tag .remove-assignee:hover {
  background-color: #ef4444;
  color: white;
}
.task-form-wrapper .days-selector {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
}
.task-form-wrapper .days-selector .day-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.5rem 0.875rem;
  border: 1px solid #d1d5db;
  border-radius: 1.125rem;
  background-color: #ffffff;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  color: #374151;
  position: relative;
}
.task-form-wrapper .days-selector .day-checkbox input[type=checkbox] {
  appearance: none;
  width: 1rem;
  height: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  background: white;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
}
.task-form-wrapper .days-selector .day-checkbox input[type=checkbox]:checked {
  border-color: var(--primary-color);
  background-color: var(--primary-color);
}
.task-form-wrapper .days-selector .day-checkbox:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}
.task-form-wrapper .days-selector .day-checkbox:has(input:checked) {
  border-color: var(--primary-color);
  background-color: #eff6ff;
}
.task-form-wrapper .frequency-dropdown {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.task-form-wrapper .frequency-dropdown:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.task-form-wrapper .frequency-dropdown:hover:not(:focus) {
  border-color: #9ca3af;
}
.task-form-wrapper .rich-text-editor {
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background: #ffffff;
}
.task-form-wrapper .rich-text-editor .editor-toolbar {
  display: flex;
  padding: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  flex-wrap: wrap;
  gap: 0.25rem;
}
.task-form-wrapper .rich-text-editor .editor-toolbar button {
  background: none;
  border: none;
  border-radius: 0.25rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.task-form-wrapper .rich-text-editor .editor-toolbar button:hover {
  background-color: #e5e7eb;
  color: #374151;
}
.task-form-wrapper .rich-text-editor .editor-toolbar button.active {
  background-color: #3b82f6;
  color: white;
}
.task-form-wrapper .rich-text-editor .editor-toolbar .divider {
  width: 1px;
  height: 1.25rem;
  background-color: #e5e7eb;
  margin: 0 0.5rem;
  align-self: center;
}
.task-form-wrapper .rich-text-editor .link-input-panel {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.75rem;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-input {
  flex: 1 1;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions {
  display: flex;
  gap: 0.25rem;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-confirm-btn,
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-cancel-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-confirm-btn:disabled,
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-confirm-btn {
  background-color: #16a34a;
  color: white;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-confirm-btn:hover:not(:disabled) {
  background-color: #15803d;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-cancel-btn {
  background-color: #ef4444;
  color: white;
}
.task-form-wrapper .rich-text-editor .link-input-panel .link-input-container .link-actions .link-cancel-btn:hover {
  background-color: #dc2626;
}
.task-form-wrapper .rich-text-editor .editor-container {
  padding: 0.875rem;
  min-height: 100px;
}
.task-form-wrapper .rich-text-editor .editor-container .public-DraftEditor-content {
  min-height: 100px;
}
.task-form-wrapper .rich-text-editor .editor-container .public-DraftEditor-content a {
  color: #3b82f6 !important;
  text-decoration: underline !important;
  background-color: rgba(59, 130, 246, 0.1) !important;
  padding: 1px 2px !important;
  border-radius: 2px !important;
  cursor: pointer !important;
}
.task-form-wrapper .rich-text-editor .editor-container .public-DraftEditor-content a:hover {
  background-color: rgba(59, 130, 246, 0.2) !important;
}
.task-form-wrapper .rich-text-editor .editor-container .public-DraftEditorPlaceholder-root {
  color: #9ca3af;
}
.task-form-wrapper .upload-document-group {
  margin-bottom: 1.5rem;
  width: 100%;
}
.task-form-wrapper .upload-document-group .upload-document-container {
  border: 2px dashed var(--grey-main-bg);
  border-radius: 0.375rem;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafafa;
}
.task-form-wrapper .upload-document-group .upload-document-container:hover {
  border-color: var(--primary-light-color);
  background-color: var(--grey-lightest-shade);
}
.task-form-wrapper .upload-document-group .upload-document-container:focus-within {
  border-color: var(--primary-light-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.task-form-wrapper .upload-document-group .upload-document-container .upload-icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  color: #6b7280;
}
.task-form-wrapper .upload-document-group .upload-document-container .upload-icon-container span {
  font-size: 0.875rem;
  font-weight: 500;
}
.task-form-wrapper .upload-document-group .upload-document-container .upload-icon-container .upload-icon {
  color: var(--primary-light-color);
}
.task-form-wrapper .upload-document-group .upload-progress {
  margin-top: 1rem;
  text-align: center;
}
.task-form-wrapper .upload-document-group .upload-progress .progress-bar {
  width: 100%;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}
.task-form-wrapper .upload-document-group .upload-progress .progress-bar .progress {
  height: 100%;
  background-color: #3b82f6;
  border-radius: 4px;
  transition: width 0.3s ease;
}
.task-form-wrapper .upload-document-group .upload-progress span {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
}
.task-form-wrapper .upload-document-group .uploaded-file {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background-color: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 0.375rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.task-form-wrapper .upload-document-group .uploaded-file a {
  color: #0369a1;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  flex: 1 1;
}
.task-form-wrapper .upload-document-group .uploaded-file a:hover {
  text-decoration: underline;
}
.task-form-wrapper .upload-document-group .uploaded-file .cancel-upload-button {
  background-color: #ef4444;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.task-form-wrapper .upload-document-group .uploaded-file .cancel-upload-button:hover {
  background-color: #dc2626;
}
.task-form-wrapper .upload-document-group .uploaded-file .cancel-upload-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);
}
.task-form-wrapper .form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}
@media (max-width: 768px) {
  .task-form-wrapper .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.task-form-wrapper .form-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .task-form-wrapper .form-actions {
    flex-direction: column;
  }
}
.task-form-wrapper .form-actions .btn-save {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .task-form-wrapper .form-actions .btn-save {
    width: 100%;
  }
}
.task-form-wrapper .form-actions .btn-save {
  background-color: var(--primary-color);
  color: white;
}
.task-form-wrapper .form-actions .btn-save:hover {
  background-color: var(--primary-light-color);
}
.task-form-wrapper .form-actions .btn-save:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.task-form-wrapper .form-actions .btn-save:focus {
  outline: none;
}
.task-form-wrapper .form-actions .btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.task-form-wrapper .form-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}
.task-form-wrapper div[role=alert] {
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.modal-mode-task-content-task-form-wrapper {
  width: 100%;
  border: none;
  box-shadow: none;
}

@keyframes task-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 1024px) {
  .task-form-container .date-time-wrapper {
    flex-direction: column;
    gap: 0.5rem;
  }
  .task-form-container .task-form-wrapper {
    width: 85%;
  }
}
@media (max-width: 768px) {
  .task-form-container .task-form-wrapper {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .task-form-container {
    padding: 0.5rem;
  }
  .task-form-container .task-form-wrapper {
    padding: 0.75rem;
    width: 100%;
  }
  .task-form-container .task-form-content,
  .task-form-container .form-content {
    padding: 1rem;
    margin: 0 -0.75rem -0.75rem -0.75rem;
  }
  .task-form-container .task-form-header .modal-mode-task-content-task-form-title {
    font-size: 0.8rem;
  }
  .task-form-container .task-form-header .task-form-title {
    font-size: 1.125rem;
  }
  .task-form-container .form-group input,
  .task-form-container .form-group select {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .task-form-container .form-actions .btn-save,
  .task-form-container .form-actions .btn-cancel {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media print {
  .task-form-container {
    background: white;
    padding: 0;
  }
  .task-form-container .task-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .task-form-container .form-actions,
  .task-form-container .task-form-close-button,
  .task-form-container .upload-document-container {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/TaskForm/TaskForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAEE;EAVF;IAWI,aAAA;EACF;AACF;;AAEA;EACE,wBAAA;EACC,gBAAA;AACH;;AAGA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,qCAAA;EACA,UAAA;AAAF;AAEE;EATF;IAUI,aAAA;IACA,WAAA;EACF;AACF;AAEE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAAN;AAEM;EANF;IAOI,kBAAA;EACN;AACF;AAEI;EACE,4BAAA;EACA,2BAAA;AAAN;AAGI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AADN;AAGM;EACE,cAAA;EACA,yBAAA;AADR;AAOE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;AALJ;AAOI;;EAEE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AALN;AAQI;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AANN;AASI;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;AAPN;AAUM;EACE,YAAA;AARR;AAYI;EACE,aAAA;EACA,YAAA;AAVN;AAaI;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;AAXN;AAaM;EACE,YAAA;EACA,2BAAA;AAXR;AAcM;EACE,gBAAA;EACA,wCAAA;AAZR;AAeM;EACE,mBAAA;EACA,YAAA;EACA,eAAA;AAbR;AAeQ;EACE,YAAA;AAbV;AAoBE;EACE,YAAA;EACA,2CAAA;EACA,gBAAA;AAlBJ;AAsBE;EACE,aAAA;EACA,yCAAA;EACA,oCAAA;EACA,gBAAA;EACA,gBAAA;AApBJ;AAsBI;EACE,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AApBN;AAsBM;EACE,uCAAA;EACA,cAAA;EACA,8CAAA;AApBR;AAuBM;EACE,4CAAA;AArBR;AA0BE;EACE,sBAAA;EACA,oBAAA;AAxBJ;AA4BE;;EAEE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,iCAAA;AA1BJ;AA4BI;EATF;;IAUI,aAAA;IACA,2BAAA;EAxBJ;AACF;AA4BE;EACE,qBAAA;AA1BJ;AA4BI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AA1BN;AA6BI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;AA3BN;AAgCE;EACE,qBAAA;EACA,WAAA;AA9BJ;AAgCI;EACE,gBAAA;AA9BN;AAiCI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA/BN;AAiCM;EACE,cAAA;EACA,oBAAA;AA/BR;AAoCI;;;;;;;;EAQE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAlCN;AAoCM;;;;;;;;EACE,aAAA;EACA,wCAAA;EACA,6CAAA;AA3BR;AA8BM;;;;;;;;EACE,+BAAA;AArBR;AAwBM;;;;;;;;EACE,wBAAA;AAfR;AAkBM;;;;;;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AATR;AAaI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAXN;AAeI;EACE,kBAAA;AAbN;AAeM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,qFAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;AAbR;AAeQ;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AAbV;AAeU;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AAbZ;AAeY;EACE,mBAAA;EACA,cAAA;AAbd;AAgBY;EACE,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,+CAAA;AAdd;AAmBQ;EACE,iBAAA;EACA,gBAAA;AAjBV;AAmBU;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AAjBZ;AAmBY;EACE,mBAAA;AAjBd;AAoBY;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AAlBd;AAoBc;EACE,gBAAA;AAlBhB;AAuBc;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AArBhB;AAwBc;EACE,kBAAA;EACA,cAAA;EACA,mGAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AAtBhB;AAyBc;EACE,kBAAA;EACA,cAAA;AAvBhB;AA4BU;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA1BZ;AAkCE;;EAEE,aAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;AAhCJ;AAkCI;EAPF;;IAQI,sBAAA;IACA,WAAA;EA9BJ;AACF;AAgCI;;;;EAEE,SAAA;EACA,gBAAA;AA5BN;AA8BM;;;;EACE,aAAA;EACA,yBAAA;AAzBR;AA4BM;;;;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAvBR;AAyBQ;;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AApBV;AAuBQ;;;;EACE,qBAAA;AAlBV;AAyBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAvBJ;AAyBI;EACE,WAAA;AAvBN;AA0BI;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAxBN;AA0BM;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AAxBR;AA0BQ;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAxBV;AA0BU;EACE,yBAAA;EACA,YAAA;AAxBZ;AAgCE;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA9BJ;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AA9BN;AAgCM;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AA9BR;AAgCQ;EACE,kCAAA;EACA,sCAAA;AA9BV;AAkCM;EACE,yBAAA;EACA,qBAAA;AAhCR;AAmCM;EACE,kCAAA;EACA,yBAAA;AAjCR;AAuCE;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AArCJ;AAuCI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AArCN;AAwCI;EACE,qBAAA;AAtCN;AA2CE;EACE,yBAAA;EACA,uBAAA;EACA,mBAAA;AAzCJ;AA2CI;EACE,aAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EACA,eAAA;EACA,YAAA;AAzCN;AA2CM;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAzCR;AA2CQ;EACE,yBAAA;EACA,cAAA;AAzCV;AA4CQ;EACE,yBAAA;EACA,YAAA;AA1CV;AA8CM;EACE,UAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AA5CR;AAgDI;EACE,yBAAA;EACA,gCAAA;EACA,gBAAA;AA9CN;AAgDM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;AA9CR;AAgDQ;EACE,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AA9CV;AAgDU;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA9CZ;AAkDQ;EACE,aAAA;EACA,YAAA;AAhDV;AAkDU;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,iCAAA;AAhDZ;AAkDY;;EACE,YAAA;EACA,mBAAA;AA/Cd;AAmDU;EACE,yBAAA;EACA,YAAA;AAjDZ;AAmDY;EACE,yBAAA;AAjDd;AAqDU;EACE,yBAAA;EACA,YAAA;AAnDZ;AAqDY;EACE,yBAAA;AAnDd;AA0DI;EACE,iBAAA;EACA,iBAAA;AAxDN;AA0DM;EACE,iBAAA;AAxDR;AA0DQ;EACE,yBAAA;EACA,qCAAA;EACA,oDAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;AAxDV;AA0DU;EACE,oDAAA;AAxDZ;AA6DM;EACE,cAAA;AA3DR;AAiEE;EACE,qBAAA;EACA,WAAA;AA/DJ;AAiEI;EACE,sCAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AA/DN;AAiEM;EACE,wCAAA;EACA,4CAAA;AA/DR;AAkEM;EACE,wCAAA;EACA,6CAAA;AAhER;AAmEM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAjER;AAmEQ;EACE,mBAAA;EACA,gBAAA;AAjEV;AAoEQ;EACE,iCAAA;AAlEV;AAuEI;EACE,gBAAA;EACA,kBAAA;AArEN;AAuEM;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AArER;AAuEQ;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;AArEV;AAyEM;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AAvER;AA2EI;EACE,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAzEN;AA2EM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AAzER;AA2EQ;EACE,0BAAA;AAzEV;AA6EM;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA3ER;AA6EQ;EACE,yBAAA;AA3EV;AA8EQ;EACE,aAAA;EACA,4CAAA;AA5EV;AAmFE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AAjFJ;AAmFI;EALF;IAMI,sBAAA;IACA,WAAA;EAhFJ;AACF;AAoFE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAlFJ;AAoFI;EAPF;IAQI,sBAAA;EAjFJ;AACF;AAmFI;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAjFN;AAmFM;EAVF;IAWI,WAAA;EAhFN;AACF;AAmFI;EACE,sCAAA;EACA,YAAA;AAjFN;AAmFM;EACE,4CAAA;AAjFR;AAoFM;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AAlFR;AAqFM;EACE,aAAA;AAnFR;AAuFI;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AArFN;AAuFM;EACE,yBAAA;AArFR;AA2FE;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AAzFJ;;AA6FE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AA1FJ;;AA+FA;EACE;IACE,UAAA;IACA,2BAAA;EA5FF;EA+FA;IACE,UAAA;IACA,wBAAA;EA7FF;AACF;AAgGA;EACE;IACE,UAAA;IACA,2BAAA;EA9FF;EAiGA;IACE,UAAA;IACA,wBAAA;EA/FF;AACF;AAmGA;EACE,UAAA;AAjGF;;AAoGA;EACE,mBAAA;EACA,kBAAA;AAjGF;;AAoGA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AAjGF;;AAoGA;EACE,mBAAA;AAjGF;;AAqGA;EAEI;IACE,sBAAA;IACA,WAAA;EAnGJ;EAsGE;IACE,UAAA;EApGJ;AACF;AAwGA;EAEI;IACE,WAAA;EAvGJ;AACF;AA2GA;EACE;IACE,eAAA;EAzGF;EA2GE;IACE,gBAAA;IACA,WAAA;EAzGJ;EA4GE;;IAEE,aAAA;IACA,oCAAA;EA1GJ;EA8GI;IACE,iBAAA;EA5GN;EA+GI;IACE,mBAAA;EA7GN;EAkHI;;IAEE,iBAAA;IACA,oBAAA;EAhHN;EAqHI;;IAEE,oBAAA;IACA,oBAAA;EAnHN;AACF;AAyHA;EACE;IACE,iBAAA;IACA,UAAA;EAvHF;EAyHE;IACE,gBAAA;IACA,sBAAA;EAvHJ;EA0HE;;;IAGE,aAAA;EAxHJ;AACF","sourcesContent":["// Main Container - Match ExpenseForm styling\n.task-form-container {\n  min-height: calc(100vh - 118px);\n  background: var(--grey-shade-three);\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n}\n\n.modal-mode-task-content-task-form-container {\n  padding: 0rem !important;\n   min-height:auto;\n}\n\n// Form Wrapper - Match ExpenseForm wrapper structure\n.task-form-wrapper {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  animation: task-fade-in 0.3s ease-out;\n  width: 70%;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n    width: 100%;\n  }\n\n  // Header styling\n  .task-form-header {\n    position: relative;\n    text-align: center;\n    margin-bottom: 0rem;\n\n    .task-form-title {\n      font-size: 1.3rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0;\n\n      @media (max-width: 768px) {\n        font-size: 1.25rem;\n      }\n    }\n\n    .modal-mode-task-content-task-form-title {\n      font-size: 1.3rem !important;\n      font-weight: 500 !important;\n    }\n\n    .task-form-close-button {\n      position: absolute;\n      top: 0;\n      right: 0;\n      font-size: 24px;\n      background: transparent;\n      border: none;\n      color: #374151;\n      cursor: pointer;\n      z-index: 2;\n      width: 32px;\n      height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 0.25rem;\n      transition: all 0.2s ease;\n\n      &:hover {\n        color: #111827;\n        background-color: #f3f4f6;\n      }\n    }\n  }\n\n  // Status Section Styling - NEW\n  .task-status-section {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n    margin: 1.5rem 0 0 0;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.375rem;\n    background-color: #f9fafb;\n\n    .current-status,\n    .status-actions {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      gap: 0.75rem;\n    }\n\n    .status-label {\n      font-weight: 500;\n      font-size: 0.875rem;\n      color: #374151;\n    }\n\n    .status-badge {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.5rem;\n      padding: 0.375rem 0.875rem;\n      border-radius: 9999px; // Pill shape\n      font-size: 0.8125rem;\n      font-weight: 500;\n      color: white;\n      //background-color: var(--success-color);\n\n      svg {\n        color: white;\n      }\n    }\n    \n    .status-buttons {\n      display: flex;\n      gap: 0.75rem;\n    }\n\n    .status-button {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.5rem;\n      padding: 0.375rem 0.875rem;\n      border: 1.5px solid; // Color set via inline style\n      border-radius: 0.375rem;\n      font-size: 0.875rem;\n      font-weight: 500;\n      cursor: pointer;\n      background-color: transparent;\n      transition: all 0.2s ease-in-out;\n      \n      &:hover:not(:disabled) {\n        opacity: 0.8;\n        transform: translateY(-1px);\n      }\n      \n      &.active {\n        font-weight: 600;\n        box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n      }\n      \n      &:disabled {\n        cursor: not-allowed;\n        opacity: 0.6;\n        transform: none;\n\n        &:hover {\n          opacity: 0.6;\n        }\n      }\n    }\n  }\n\n  // Divider styling\n  .task-form-divider {\n    border: none;\n    border-top: 1px solid var(--grey-shade-two);\n    margin: 1.5rem 0;\n  }\n\n  // Tab styling - updated to match form sections better\n  .task-tabs {\n    display: flex;\n    border: 1px solid var(--grey-shade-three);\n    border-radius: 0.375rem 0.375rem 0 0;\n    overflow: hidden;\n    margin-bottom: 0;\n\n    .tab-button {\n      flex: 1;\n      padding: 1rem 1.5rem;\n      background: #ffffff;\n      border: none;\n      font-size: 0.875rem;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      text-align: center;\n      color: #6b7280;\n\n      &.active {\n        background-color: var(--grey-shade-two);\n        color: #374151;\n        border-bottom: 2px solid var(--grey-shade-one);\n      }\n\n      &:hover:not(.active) {\n        background-color: var(--grey-lightest-shade);\n      }\n    }\n  }\n\n  .modal-mode-task-content {\n    width: 100% !important;\n    margin: 0 !important;\n  }\n\n  // Form content styling - updated to match the wrapper structure\n  .task-form-content,\n  .form-content {\n    padding: 1.5rem;\n    border: 1px solid #e5e7eb;\n    border-top: none;\n    border-radius: 0 0 0.375rem 0.375rem;\n    background-color: #ffffff;\n    margin: 0 -1.5rem -1.5rem -1.5rem;\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n      margin: 0 -1rem -1rem -1rem;\n    }\n  }\n\n  // Form sections - NEW: Add section styling like ExpenseForm\n  .form-section {\n    margin-bottom: 1.5rem; \n\n    &:last-of-type {\n      border-bottom: none;\n      margin-bottom: 0;\n      padding-bottom: 0;\n    }\n\n    h3 {\n      font-size: 1rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 1rem 0;\n      padding-bottom: 0.5rem;\n      border-bottom: 1px solid var(--grey-shade-two);\n    }\n  }\n\n  // Form groups\n  .form-group {\n    margin-bottom: 0.7rem;\n    width: 100%;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .label-task {\n      display: block;\n      margin-bottom: 0.5rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      color: #374151;\n\n      .required {\n        color: #ef4444;\n        margin-left: 0.25rem;\n      }\n    }\n\n    // Input styling to match ExpenseForm\n    input[type=\"text\"],\n    input[type=\"date\"],\n    input[type=\"time\"],\n    input[type=\"url\"],\n    select,\n    .custom-dropdown-input,\n    .textInput,\n    .selectInput {\n      width: 100%;\n      padding: 0.5rem;\n      border: 1px solid #d1d5db;\n      border-radius: 0.25rem;\n      font-size: 0.875rem;\n      font-family: inherit;\n      color: #374151 !important;\n      background: #ffffff;\n      box-sizing: border-box;\n      height: 2.5rem;\n\n      &:focus {\n        outline: none;\n        border-color: var(--primary-light-color);\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n      &:hover:not(:focus) {\n        border-color: var(grey-main-bg);\n      }\n\n      &::placeholder {\n        color: var(grey-main-bg);\n      }\n\n      &:disabled {\n        background-color: #e9ecef;\n        color: #6b7280;\n        cursor: not-allowed;\n      }\n    }\n\n    select {\n      appearance: none;\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n      background-position: right 0.5rem center;\n      background-repeat: no-repeat;\n      background-size: 1.5rem 1.5rem;\n      padding-right: 2.5rem;\n    }\n\n    // Case selector dropdown - Match ExpenseForm exactly\n    .case-selector {\n      position: relative;\n\n      .dropdown-content {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        width: 100%;\n        background: #ffffff;\n        border: 1px solid #d1d5db;\n        border-radius: 0.375rem;\n        z-index: 1000;\n        box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n        margin-top: 0.25rem;\n        overflow: hidden;\n        animation: dropdown-fade-in 0.2s ease-out;\n\n        .dropdown-tabs {\n          display: flex;\n          background: #f9fafb;\n          border-bottom: 1px solid #e5e7eb;\n\n          button {\n            flex: 1;\n            padding: 0.75rem 1rem;\n            border: none;\n            background: transparent;\n            color: #6b7280;\n            font-weight: 500;\n            font-size: 0.875rem;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            border-bottom: 2px solid transparent;\n\n            &:hover {\n              background: #f3f4f6;\n              color: #374151;\n            }\n\n            &.active {\n              background: #ffffff;\n              color: var(--primary-light-color);\n              font-weight: 600;\n              border-bottom-color: var(--primary-light-color);\n            }\n          }\n        }\n\n        .dropdown-options {\n          max-height: 250px;\n          overflow-y: auto;\n\n          .dropdown-option {\n            padding: 0.75rem 1rem;\n            cursor: pointer;\n            border-bottom: 1px solid #f3f4f6;\n            transition: all 0.2s ease;\n\n            &:hover {\n              background: #f9fafb;\n            }\n\n            &.selected {\n              background: #eff6ff;\n              color: #1e40af;\n              border-left: 3px solid #3b82f6;\n\n              .case-parties {\n                font-weight: 600;\n              }\n            }\n\n            .case-info {\n              .case-parties {\n                font-weight: 500;\n                color: #374151;\n                font-size: 0.875rem;\n                margin-bottom: 0.25rem;\n                line-height: 1.4;\n              }\n\n              .case-ref {\n                font-size: 0.75rem;\n                color: #6b7280;\n                font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas, \"Liberation Mono\", Menlo, monospace;\n                background: #f3f4f6;\n                padding: 0.125rem 0.375rem;\n                border-radius: 0.25rem;\n                display: inline-block;\n                margin-bottom: 0.25rem;\n              }\n\n              .case-number {\n                font-size: 0.75rem;\n                color: #9ca3af;\n              }\n            }\n          }\n\n          .no-data {\n            padding: 2rem 1rem;\n            text-align: center;\n            color: #6b7280;\n            font-style: italic;\n            font-size: 0.875rem;\n          }\n        }\n      }\n    }\n  }\n\n  // Two column layout - Match ExpenseForm\n  .date-time-wrapper,\n  .expense-form-flex-row {\n    display: flex;\n    gap: 1rem;\n    width: 100%;\n    margin-bottom: 0.7rem;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n\n    .date-time-group,\n    .expense-form-col-half {\n      flex: 1;\n      margin-bottom: 0;\n\n      .time-div-task-content {\n        display: flex;\n        justify-content: flex-end;\n      }\n\n      .date-time-input-task {\n        width: 100%;\n        padding: 0.5rem;\n        border: 1px solid #d1d5db;\n        border-radius: 0.25rem;\n        font-size: 0.875rem;\n        font-family: inherit;\n        color: #374151;\n        background: #ffffff;\n        box-sizing: border-box;\n        height: 2.5rem;\n\n        &:focus {\n          outline: none;\n          border-color: #3b82f6;\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        }\n\n        &:hover:not(:focus) {\n          border-color: #9ca3af;\n        }\n      }\n    }\n  }\n\n  // Assignee section\n  .assignee-section {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n\n    .dropdown-container {\n      width: 100%;\n    }\n\n    .assignee-tags {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.5rem;\n\n      .assignee-tag {\n        display: flex;\n        align-items: center;\n        background-color: #eff6ff;\n        border: 1px solid #dbeafe;\n        border-radius: 0.375rem;\n        padding: 0.375rem 0.75rem;\n        font-size: 0.875rem;\n        color: #374151;\n\n        .remove-assignee {\n          margin-left: 0.5rem;\n          background: none;\n          border: none;\n          color: #6b7280;\n          cursor: pointer;\n          font-size: 1rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 1.25rem;\n          height: 1.25rem;\n          border-radius: 50%;\n          transition: all 0.2s ease;\n\n          &:hover {\n            background-color: #ef4444;\n            color: white;\n          }\n        }\n      }\n    }\n  }\n\n  // Days selector for recurring tasks\n  .days-selector {\n    display: flex;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    margin-top: 0.5rem;\n\n    .day-checkbox {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      cursor: pointer;\n      padding: 0.5rem 0.875rem;\n      border: 1px solid #d1d5db;\n      border-radius: 1.125rem;\n      background-color: #ffffff;\n      transition: all 0.2s ease;\n      font-size: 0.875rem;\n      color: #374151;\n      position: relative;\n\n      input[type=\"checkbox\"] {\n        appearance: none;\n        width: 1rem;\n        height: 1rem;\n        border: 1px solid #d1d5db;\n        border-radius: 0.25rem;\n        background: white;\n        position: relative;\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        &:checked {\n          border-color: var(--primary-color);\n          background-color: var(--primary-color);\n        }\n      }\n\n      &:hover {\n        background-color: #f9fafb;\n        border-color: #9ca3af;\n      }\n\n      &:has(input:checked) {\n        border-color: var(--primary-color);\n        background-color: #eff6ff;\n      }\n    }\n  }\n\n  // Frequency dropdown\n  .frequency-dropdown {\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    font-family: inherit;\n    color: #374151;\n    background: #ffffff;\n    box-sizing: border-box;\n    height: 2.5rem;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n    background-position: right 0.5rem center;\n    background-repeat: no-repeat;\n    background-size: 1.5rem 1.5rem;\n    padding-right: 2.5rem;\n\n    &:focus {\n      outline: none;\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n\n    &:hover:not(:focus) {\n      border-color: #9ca3af;\n    }\n  }\n\n  // Rich text editor\n  .rich-text-editor {\n    border: 1px solid #d1d5db;\n    border-radius: 0.375rem;\n    background: #ffffff;\n\n    .editor-toolbar {\n      display: flex;\n      padding: 0.5rem;\n      border-bottom: 1px solid #e5e7eb;\n      background-color: #f9fafb;\n      border-top-left-radius: 0.375rem;\n      border-top-right-radius: 0.375rem;\n      flex-wrap: wrap;\n      gap: 0.25rem;\n\n      button {\n        background: none;\n        border: none;\n        border-radius: 0.25rem;\n        color: #6b7280;\n        cursor: pointer;\n        padding: 0.375rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background-color: #e5e7eb;\n          color: #374151;\n        }\n\n        &.active {\n          background-color: #3b82f6;\n          color: white;\n        }\n      }\n\n      .divider {\n        width: 1px;\n        height: 1.25rem;\n        background-color: #e5e7eb;\n        margin: 0 0.5rem;\n        align-self: center;\n      }\n    }\n\n    .link-input-panel {\n      background-color: #f8f9fa;\n      border-bottom: 1px solid #e5e7eb;\n      padding: 0.75rem;\n\n      .link-input-container {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        width: 100%;\n\n        .link-input {\n          flex: 1;\n          padding: 0.5rem 0.75rem;\n          border: 1px solid #d1d5db;\n          border-radius: 0.25rem;\n          font-size: 0.875rem;\n\n          &:focus {\n            outline: none;\n            border-color: #3b82f6;\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n          }\n        }\n\n        .link-actions {\n          display: flex;\n          gap: 0.25rem;\n\n          .link-confirm-btn,\n          .link-cancel-btn {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 2rem;\n            height: 2rem;\n            border: none;\n            border-radius: 0.25rem;\n            cursor: pointer;\n            transition: background-color 0.2s;\n\n            &:disabled {\n              opacity: 0.5;\n              cursor: not-allowed;\n            }\n          }\n\n          .link-confirm-btn {\n            background-color: #16a34a;\n            color: white;\n\n            &:hover:not(:disabled) {\n              background-color: #15803d;\n            }\n          }\n\n          .link-cancel-btn {\n            background-color: #ef4444;\n            color: white;\n\n            &:hover {\n              background-color: #dc2626;\n            }\n          }\n        }\n      }\n    }\n\n    .editor-container {\n      padding: 0.875rem;\n      min-height: 100px;\n\n      .public-DraftEditor-content {\n        min-height: 100px;\n\n        a {\n          color: #3b82f6 !important;\n          text-decoration: underline !important;\n          background-color: rgba(59, 130, 246, 0.1) !important;\n          padding: 1px 2px !important;\n          border-radius: 2px !important;\n          cursor: pointer !important;\n\n          &:hover {\n            background-color: rgba(59, 130, 246, 0.2) !important;\n          }\n        }\n      }\n\n      .public-DraftEditorPlaceholder-root {\n        color: #9ca3af;\n      }\n    }\n  }\n\n  // Upload document section - Match ExpenseForm exactly\n  .upload-document-group {\n    margin-bottom: 1.5rem;\n    width: 100%;\n\n    .upload-document-container {\n      border: 2px dashed var(--grey-main-bg);\n      border-radius: 0.375rem;\n      padding: 2rem;\n      text-align: center;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      background: #fafafa;\n\n      &:hover {\n        border-color: var(--primary-light-color);\n        background-color: var(--grey-lightest-shade);\n      }\n\n      &:focus-within {\n        border-color: var(--primary-light-color);\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n      .upload-icon-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 0.75rem;\n        color: #6b7280;\n\n        span {\n          font-size: 0.875rem;\n          font-weight: 500;\n        }\n\n        .upload-icon{\n          color: var(--primary-light-color);\n        }\n      }\n    }\n\n    .upload-progress {\n      margin-top: 1rem;\n      text-align: center;\n\n      .progress-bar {\n        width: 100%;\n        height: 8px;\n        background-color: #e5e7eb;\n        border-radius: 4px;\n        overflow: hidden;\n        margin-bottom: 0.5rem;\n\n        .progress {\n          height: 100%;\n          background-color: #3b82f6;\n          border-radius: 4px;\n          transition: width 0.3s ease;\n        }\n      }\n\n      span {\n        font-size: 0.75rem;\n        color: #6b7280;\n        font-weight: 500;\n      }\n    }\n\n    .uploaded-file {\n      margin-top: 1rem;\n      padding: 0.75rem 1rem;\n      background-color: #f0f9ff;\n      border: 1px solid #bae6fd;\n      border-radius: 0.375rem;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 1rem;\n\n      a {\n        color: #0369a1;\n        text-decoration: none;\n        font-weight: 500;\n        font-size: 0.875rem;\n        flex: 1;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n\n      .cancel-upload-button {\n        background-color: #ef4444;\n        color: white;\n        border: none;\n        padding: 0.375rem 0.75rem;\n        border-radius: 0.25rem;\n        font-size: 0.75rem;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background-color: #dc2626;\n        }\n\n        &:focus {\n          outline: none;\n          box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);\n        }\n      }\n    }\n  }\n\n  // Form row styling\n  .form-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n  }\n\n  // Form actions - Match ExpenseForm exactly\n  .form-actions {\n    display: flex;\n    justify-content: end;\n    gap: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e5e7eb;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n\n    .btn-save{\n      padding: 0.75rem 1.5rem;\n      border: none;\n      border-radius: 0.375rem;\n      font-size: 0.875rem;\n      font-weight: 500;\n      cursor: pointer;\n      min-width: 120px;\n      transition: all 0.2s ease;\n\n      @media (max-width: 768px) {\n        width: 100%;\n      }\n    }\n\n    .btn-save {\n      background-color: var(--primary-color);\n      color: white;\n\n      &:hover{\n        background-color: var(--primary-light-color);\n      }\n\n      &:disabled {\n        background-color: #d1d5db;\n        color: #9ca3af;\n        cursor: not-allowed;\n        opacity: 0.6;\n      }\n\n      &:focus {\n        outline: none;\n      }\n    }\n\n    .btn-cancel {\n      padding: 8px 16px;\n      border: 1px solid #ddd;\n      background: white;\n      color: #666;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 14px;\n\n      &:hover {\n        background-color: #f8f9fa;\n      }\n    }\n  }\n\n  // Success/Error messages\n  div[role=\"alert\"] {\n    border-radius: 0.375rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n  }\n}\n\n  .modal-mode-task-content-task-form-wrapper {\n    width: 100%;\n    border: none;\n    box-shadow: none;\n  }\n\n\n// Animations\n@keyframes task-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes dropdown-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Scrollbar styling for dropdown\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {\n  width: 6px;\n}\n\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n  transition: background-color 0.2s ease;\n}\n\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n// Responsive design improvements\n@media (max-width: 1024px) {\n  .task-form-container {\n    .date-time-wrapper {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n\n    .task-form-wrapper {\n      width: 85%;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .task-form-container {\n    .task-form-wrapper {\n      width: 100%;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .task-form-container {\n    padding: 0.5rem;\n\n    .task-form-wrapper {\n      padding: 0.75rem;\n      width: 100%;\n    }\n\n    .task-form-content,\n    .form-content {\n      padding: 1rem;\n      margin: 0 -0.75rem -0.75rem -0.75rem;\n    }\n\n    .task-form-header {\n      .modal-mode-task-content-task-form-title {\n        font-size: 0.8rem;\n      }\n\n      .task-form-title {\n        font-size: 1.125rem;\n      }\n    }\n\n    .form-group {\n      input,\n      select {\n        padding: 0.375rem;\n        font-size: 0.8125rem;\n      }\n    }\n\n    .form-actions {\n      .btn-save,\n      .btn-cancel {\n        padding: 0.5rem 1rem;\n        font-size: 0.8125rem;\n      }\n    }\n  }\n}\n\n// Print styles\n@media print {\n  .task-form-container {\n    background: white;\n    padding: 0;\n\n    .task-form-wrapper {\n      box-shadow: none;\n      border: 1px solid #000;\n    }\n\n    .form-actions,\n    .task-form-close-button,\n    .upload-document-container {\n      display: none;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
